import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import useReportContext from '../context/useReportContext';

function PerMDSummaryTable() {
  const { reportData, exportPerMDSummary } = useContext(useReportContext);

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    { field: 'rep_name', headerName: 'Med Rep Name', width: 200 },
    { field: 'rep_designation', headerName: 'Med Rep Designation', width: 200 },
    { field: 'manager_name', headerName: 'Manager Name', width: 200 },
    { field: 'md_name', headerName: 'MD Name', width: 200 },
    { field: 'md_count', headerName: 'MD Count', width: 200 },
    { field: 'classification', headerName: 'Classification', width: 200 },
    { field: 'target', headerName: 'Target', width: 200 },
    { field: 'actual_call', headerName: 'Calls', width: 200 },
    {
      field: 'call_rate',
      headerName: 'Call Rate W/O VMC',
      width: 150,

      renderCell: ({ row }) => `${parseFloat(row.call_rate).toFixed(2)}%`,
    },
    { field: 'vmc_call', headerName: 'VMC', width: 200 },
    {
      field: 'call_vmc_rate',
      headerName: 'Call Rate with VMC',
      width: 150,

      renderCell: ({ row }) => `${parseFloat(row.call_vmc_rate).toFixed(2)}%`,
    },
    { field: 'reach', headerName: 'Reach', width: 200 },
    {
      field: 'concentration',
      headerName: 'concentration',
      width: 200,
      renderCell: ({ row }) => `${parseFloat(row.concentration).toFixed(2)}%`,
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            color='success'
            onClick={exportPerMDSummary}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export Per MD Summary
          </Button>
        </Box>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          <DataGridPro
            loading={reportData.md_loading}
            rows={reportData.md_data}
            columns={columns}
            sortModel={sortModel}
            initialState={{
              ...reportData.md_data.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default PerMDSummaryTable;
